/**
 * Stable, shared empty-collection references. Use these as default values
 * for useQuery / useInfiniteQuery results to avoid creating a new reference
 * on every render, which breaks dependency-array equality checks and can
 * trigger infinite re-render loops.
 *
 * See: ClientGalleryPage infinite-loop fix (commit 3c0d0b89) for the
 * original incident. That fix used per-file module-level constants; this
 * file is the canonical home going forward.
 *
 * The arrays are Object.freeze'd at runtime to catch accidental mutation,
 * but typed as mutable T[] to avoid readonly friction at every call site.
 * Code that mutates a useQuery default is already buggy regardless of types.
 */
const _EMPTY_ARRAY = Object.freeze([]) as never[]
const _EMPTY_OBJECT = Object.freeze({}) as Record<string, never>
const _EMPTY_MAP = Object.freeze(new Map()) as Map<never, never>
const _EMPTY_SET = Object.freeze(new Set()) as Set<never>

export const EMPTY_ARRAY = _EMPTY_ARRAY
export const EMPTY_OBJECT = _EMPTY_OBJECT
export const EMPTY_MAP = _EMPTY_MAP
export const EMPTY_SET = _EMPTY_SET

// Typed casts for site-specific use:
export const emptyArray = <T>() => _EMPTY_ARRAY as T[]
export const emptyMap = <K, V>() => _EMPTY_MAP as unknown as Map<K, V>
export const emptySet = <T>() => _EMPTY_SET as unknown as Set<T>
